import { render, staticRenderFns } from "./Blade3.vue?vue&type=template&id=4d74a56b"
import script from "./Blade3.vue?vue&type=script&lang=js"
export * from "./Blade3.vue?vue&type=script&lang=js"
import style0 from "./Blade3.vue?vue&type=style&index=0&id=4d74a56b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports